import { useMemo, useState } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import BackTop from '@/components/base/BackTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SectionTitle from '@/components/base/SectionTitle';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

const filters = [
  { key: 'all', label: '全部内容' },
  { key: 'daily', label: '师门日常' },
  { key: 'cp', label: 'CP考据' },
  { key: 'character', label: '人物考据' },
];

const pageSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '师兄啊师兄师门日常合集',
  url: 'https://pxwfrw.cn/daily',
  description: '师兄啊师兄师门日常高甜片段与考据文章合集，持续更新。',
  inLanguage: 'zh-CN',
};

export default function Daily() {
  const [active, setActive] = useState('all');
  const list = useMemo(
    () => (active === 'all' ? articles : articles.filter((a) => a.category === active)),
    [active],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />
      <Header />
      <main className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '师门日常' }]} />
        <header className="mb-6">
          <h1 className="font-heading text-3xl font-black tracking-wide text-foreground-950 md:text-4xl">
            师门日常合集
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            师门日常高甜片段、CP 考据、人物考据持续更新。从度仙门的一日到破天峰的酒会，
            把同门情谊的每个细节都慢慢翻给你看。
          </p>
        </header>

        <div className="mb-8 inline-flex flex-wrap gap-1 rounded-full border border-background-200/70 bg-background-50 px-1 py-1">
          {filters.map((f) => (
            <button
              key={f.key}
              type="button"
              onClick={() => setActive(f.key)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === f.key ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <section aria-label="文章列表">
          {list.length > 0 ? (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {list.map((a) => (
                <ArticleCard key={a.id} article={a} />
              ))}
            </div>
          ) : (
            <div className="rounded-xl border border-background-200/70 bg-background-100/60 p-10 text-center">
              <p className="font-heading text-lg font-bold text-foreground-950">这个分类还没有内容</p>
              <p className="mt-2 text-sm text-foreground-600">我们正在努力整理中，先去其他栏目逛逛吧。</p>
            </div>
          )}
        </section>

        <section aria-label="相关栏目" className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Link to="/characters" className="group flex items-center justify-between rounded-xl border border-background-200/70 bg-background-100/60 p-5 transition-colors hover:border-primary-200">
            <div>
              <p className="font-heading text-lg font-bold text-foreground-950">人物关系图谱</p>
              <p className="mt-1 text-sm text-foreground-600">先把核心人物认全，磕糖才有方向。</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-primary-500 transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/cp" className="group flex items-center justify-between rounded-xl border border-background-200/70 bg-background-100/60 p-5 transition-colors hover:border-primary-200">
            <div>
              <p className="font-heading text-lg font-bold text-foreground-950">CP线专题</p>
              <p className="mt-1 text-sm text-foreground-600">CP线发展脉络与高甜名场面全梳理。</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-primary-500 transition-transform group-hover:translate-x-1" />
          </Link>
        </section>
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}